import React from 'react'
import {
    Dialog,
    DialogActions,
    Button,
    DialogContent,
    DialogProps,
} from '@mui/material'
import AppDialogTitle from './AppDialogTitle'
import CloseDialogButton from './CloseDialogButton'

interface AlertDialogProps extends DialogProps {
    open: boolean
    onClose: () => void
    children: React.ReactNode

    /**
     * Specify the dialog's title
     * @default 'OrderWire'
     */
    title?: string

    /**
     * Text showing in the button.
     * @default string 'OK'
     */
    buttonText?: string

    /**
     * TRUE will hide OK Button.
     * @default undefined
     */
    hideOKBtn?: boolean

    /**
     * TRUE will hide close button top-right.
     * @default undefined
     */
    hideCloseBtn?: boolean
}
function AlertDialog(props: AlertDialogProps) {
    const {
        onClose,
        open,
        children,
        title = 'OrderWire',
        buttonText = 'OK',
        hideOKBtn,
        hideCloseBtn,
        ...other
    } = props

    const handleClose = (event: object, reason: string) => {
        if (reason === 'backdropClick') {
        } else {
            onClose()
        }
    }

    return (
        <Dialog open={open} onClose={handleClose} {...other}>
            <AppDialogTitle text={title} />
            {!hideCloseBtn && (
                <CloseDialogButton
                    dialogName="alert dialog"
                    onClick={() => onClose()}
                />
            )}
            <DialogContent>{children}</DialogContent>
            {!hideOKBtn && (
                <DialogActions>
                    <Button
                        className="textUpper"
                        color="primary"
                        onClick={onClose}
                    >
                        {buttonText}
                    </Button>
                </DialogActions>
            )}
        </Dialog>
    )
}

export default AlertDialog
